import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/admin/statistics', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
      setLoading(false);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load statistics');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <p>Loading statistics...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '1rem', background: '#ffebee', color: '#c62828', borderRadius: '4px' }}>
        <p>{error}</p>
      </div>
    );
  }

  const StatCard = ({ title, value, color = '#4A90E2' }) => (
    <div style={{
      background: 'white',
      padding: '1.5rem',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      borderTop: `4px solid ${color}`
    }}>
      <h3 style={{ margin: '0 0 0.5rem 0', color: '#666', fontSize: '0.9rem', fontWeight: '500' }}>
        {title}
      </h3>
      <p style={{ margin: '0', fontSize: '2rem', fontWeight: '700', color: '#333' }}>
        {value}
      </p>
    </div>
  );

  return (
    <div>
      <h1 style={{ marginBottom: '2rem', color: '#333' }}>Dashboard</h1>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1rem',
        marginBottom: '2rem'
      }}>
        <StatCard
          title="Total Users"
          value={stats.overview.total_users}
          color="#4A90E2"
        />
        <StatCard
          title="Total Claims"
          value={stats.overview.total_claims}
          color="#5B9BD5"
        />
        <StatCard
          title="Users with Active Claims"
          value={stats.overview.users_with_active_claims}
          color="#357ABD"
        />
        <StatCard
          title="Total Communications"
          value={stats.overview.total_communications}
          color="#6BA3D9"
        />
        <StatCard
          title="Total FAQs"
          value={stats.overview.total_faqs}
          color="#4A90E2"
        />
      </div>

      <div style={{
        background: 'white',
        borderRadius: '8px',
        padding: '1.5rem',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ marginTop: '0', marginBottom: '1.5rem', color: '#333' }}>
          Claims by Status
        </h2>

        <div style={{ overflowX: 'auto' }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.9rem'
          }}>
            <thead>
              <tr style={{ background: '#f5f5f5', borderBottom: '2px solid #e0e0e0' }}>
                <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600' }}>
                  CRM Status
                </th>
                <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600' }}>
                  Client Status
                </th>
                <th style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '600' }}>
                  Active
                </th>
                <th style={{ padding: '0.75rem', textAlign: 'right', fontWeight: '600' }}>
                  Count
                </th>
              </tr>
            </thead>
            <tbody>
              {stats.statusBreakdown.map((status, index) => (
                <tr
                  key={index}
                  style={{
                    borderBottom: '1px solid #e0e0e0',
                    background: index % 2 === 0 ? 'white' : '#fafafa'
                  }}
                >
                  <td style={{ padding: '0.75rem' }}>
                    {status.crm_status || 'N/A'}
                  </td>
                  <td style={{ padding: '0.75rem' }}>
                    {status.client_status || 'Not Mapped'}
                  </td>
                  <td style={{ padding: '0.75rem', textAlign: 'center' }}>
                    <span style={{
                      padding: '0.25rem 0.75rem',
                      borderRadius: '12px',
                      fontSize: '0.8rem',
                      fontWeight: '600',
                      background: status.is_active ? '#e3f2fd' : '#f5f5f5',
                      color: status.is_active ? '#4A90E2' : '#999'
                    }}>
                      {status.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td style={{ padding: '0.75rem', textAlign: 'right', fontWeight: '600' }}>
                    {status.count}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
